var _a;
// NOTICE - THIS PATTERN ISN'T THE GLOBAL PATTTERN USED IN FINDALL (https://github.com/wix-private/santa-core/blob/05634a69bf8c0b70847fd8e6449da7afdd1fe76a/santa-core-utils/src/coreUtils/core/textPatternRecognizer.js#L10)
var PHONE_NUMBER_PATTERN = /(?:\+|\()?\d(?:[-.() \t\u00a0\u1680\u180e\u2000\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]{0,5}\d){6,16}\)?(?![<@)\w])|\*\d{4}(?![<@)\w])/;
var EMAIL_PATTERN = /(^|[\s:;,<>])([A-Z0-9][A-Z0-9._%+-]+@[A-Z0-9][A-Z0-9.-]+\.[A-Z]{2,})(?=$|[\s:;,<>])/i; // http://www.regular-expressions.info/email.html
var URL_PATTERN = /(^|[\s:;,<>])((?:https?:\/\/|www\.)[a-z0-9](?:\.?[a-z0-9\-%_])*(?:(?:\\|\/)[a-z0-9\-._~:/\\?#[\]@!$&'()*+,;=%]*)?)(?=$|[^a-z0-9\-._~:/\\?#[\]@!$&'()*+,;=%])/i;
var GLOBAL_PHONE_NUMBER_PATTERN = new RegExp(PHONE_NUMBER_PATTERN, 'g');
var GLOBAL_EMAIL_PATTERN = /([A-Z0-9][A-Z0-9._%+-]+@[A-Z0-9][A-Z0-9.-]+\.[A-Z]{2,})/gi;
var GLOBAL_URL_PATTERN = /((?:https?:\/\/|www\.)[a-z0-9](?:\.?[a-z0-9\-%_])*(?:(?:\\|\/)[a-z0-9\-._~:/\\?#[\]@!$&'()*+,;=%]*)?)/gi;
export var PatternType = {
    PHONE: 'PHONE',
    MAIL: 'MAIL',
    URL: 'URL',
};
var findPhoneNumber = function (text) {
    var matching = text.match(PHONE_NUMBER_PATTERN);
    return (matching && {
        key: matching[0],
        value: matching[0].match(/[*\d]/g).join(''),
        index: matching.index,
        pattern: PatternType.PHONE,
    });
};
var findEmail = function (text) {
    var matching = text.match(EMAIL_PATTERN);
    if (matching) {
        var prefixSize = matching[1].length;
        var mainCapture = matching[2];
        return {
            key: mainCapture,
            value: mainCapture,
            index: matching.index + prefixSize,
            pattern: PatternType.MAIL,
        };
    }
    else {
        return null;
    }
};
export var getUrlWithProtocol = function (url) {
    var beginsWithHttp = url.toLowerCase().indexOf('http') === 0;
    return beginsWithHttp ? url : "http://" + url;
};
var findUrl = function (text) {
    var matching = text.match(URL_PATTERN);
    if (matching) {
        var mainCapture = matching[2];
        var prefixSize = matching[1].length;
        var value = getUrlWithProtocol(mainCapture);
        return {
            key: mainCapture,
            value: value,
            index: matching.index + prefixSize,
            pattern: PatternType.URL,
        };
    }
    else {
        return null;
    }
};
export var replaceEmails = function (str, replacer) { return str.replace(GLOBAL_EMAIL_PATTERN, replacer); };
export var replacePhoneNumbers = function (str, replacer) {
    return str.replace(GLOBAL_PHONE_NUMBER_PATTERN, replacer);
};
export var replaceUrls = function (str, replacer) { return str.replace(GLOBAL_URL_PATTERN, replacer); };
var patternToMatchingFunc = (_a = {},
    _a[PatternType.PHONE] = findPhoneNumber,
    _a[PatternType.MAIL] = findEmail,
    _a[PatternType.URL] = findUrl,
    _a);
export function findFirstMatch(text, patterns) {
    if (patterns === void 0) { patterns = {}; }
    if (!text) {
        return null;
    }
    var matches = Object.keys(patterns)
        .filter(function (key) { return patterns[key]; })
        .map(function (key) { return patternToMatchingFunc[key](text); })
        .filter(function (value) { return value !== null; });
    var firstMatch = matches[0]
        ? matches.reduce(function (prev, curr) {
            return curr.index < prev.index ? curr : prev;
        }, matches[0])
        : null;
    return firstMatch;
}
//# sourceMappingURL=textPatterns.js.map